import React from 'react'
import { t } from 'ttag'

const WBLOpportunitiesOffered = ({ profile, section, selectedCluster }) => {
  const textContent = () => {
    return <div dangerouslySetInnerHTML={{ __html: section.body }}></div>
  }

  return (
    <div className="wbl-opportunity-block">
      {section.suppressTitle ? (
        <h4 className="profile-emphasized-heading main-title">
          <strong>{t`What types of opportunities are there?`}</strong>
        </h4>
      ) : null}

      <img
        src={'/images/headed2/new/localopportunities/participate/Opportunities.svg'}
        style={{ float: 'right', maxWidth: '40%' }}
      />
      {textContent()}
    </div>
  )
}

export default WBLOpportunitiesOffered
